module.exports = __webpack_public_path__ + "img/start_hulk.6257612b.png";